import {
  DEFAULT_SETTINGS,
  SETTINGS_STORAGE_KEYS,
} from '../constants/settings.constants'
import type { SettingsRecord } from '../models/settings.model'

/**
 * localStorage-backed CRUD for the user's app settings. Mirrors the auth /
 * meetings / notifications repo shape so a backend swap is one file change.
 */
export const settingsRepo = {
  load(): SettingsRecord {
    try {
      const raw = localStorage.getItem(SETTINGS_STORAGE_KEYS.ROOT)
      if (!raw) return DEFAULT_SETTINGS
      const parsed = JSON.parse(raw)
      if (!parsed || typeof parsed !== 'object') return DEFAULT_SETTINGS
      // Defensive merge so a missing key is back-filled with the default.
      return {
        notifications: {
          ...DEFAULT_SETTINGS.notifications,
          ...(parsed.notifications ?? {}),
        },
        sounds: { ...DEFAULT_SETTINGS.sounds, ...(parsed.sounds ?? {}) },
      }
    } catch {
      return DEFAULT_SETTINGS
    }
  },

  save(settings: SettingsRecord): void {
    localStorage.setItem(SETTINGS_STORAGE_KEYS.ROOT, JSON.stringify(settings))
  },

  clear(): void {
    localStorage.removeItem(SETTINGS_STORAGE_KEYS.ROOT)
  },
}
